import StudentProfile from '@/api/student-profile'
import ParentProfile from '@/api/parent-profile'
import StudentInquiry from '@/api/info-inquiry'
import StudyTime from '@/api/study-time'
import CorporatePartner from '@/api/corporate-partner'
import ClassOperation from '@/api/class-operation'
import SubProgram from '@/api/sub-program'
import branch from '@/api/branch'
import operationClass from '@/api/class-operation'
import bankProfile from '@/api/bank-profile'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  edit_data: {},
  itemLists: [],
  studentStatus: [],
  studyTimes: [],
  coperatePathners: [],
  provinces: [],
  districts: [],
  communes: [],
  villages: [],
  photoBlob: '',
  parent_search: '',
  status_id: 1,
  id_card_activated: null,
  photo_exists: null,
  sound_exists: null,
  linked_with_parent: null,
  is_print_card: null,
  class_id: null,
  acps_id: 'All',
  branch_id: null,
  genders: [
    {
      value: 'Male',
      description: 'Male'
    },
    {
      value: 'Female',
      description: 'Female'
    }
  ],
  bankProfiles: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_EDIT_DATA(state, data) {
    state.edit_data = data
  },
  SET_ITEM_LISTS(state, data) {
    state.itemLists = data
  },
  SET_STATUS(state, data) {
    state.studentStatus = data
  },
  SET_SUB_PROGRAM(state, data) {
    state.acps_id = data
  },
  SET_STUDY_TIMES(state, data) {
    state.studyTimes = data
  },
  SET_CORPORATE_PARTNERS(state, data) {
    state.coperatePathners = data
  },
  SET_PHOTO_BLOB(state, blob) {
    state.photoBlob = blob
  },
  SET_PROVINCES(state, data) {
    state.provinces = data
  },
  SET_DISTRICTS(state, data) {
    state.districts = data
  },
  SET_COMMUNES(state, data) {
    state.communes = data
  },
  SET_VILLAGES(state, data) {
    state.villages = data
  },
  SET_PARENT_SEARCH(state, data) {
    state.parent_search = data
  },
  SET_STATUS_ID(state, data) {
    state.status_id = data
  },
  SET_IS_PRINT_CARD(state, data) {
    state.is_print_card = data
  },
  SET_ID_CARD_ACTIVATED(state, data) {
    state.id_card_activated = data
  },
  SET_PHOTO_EXISTS(state, data) {
    state.photo_exists = data
  },
  SET_LINKED_WITH_PARENT(state, data) {
    state.linked_with_parent = data
  },
  SET_SOUND_EXISTS(state, data) {
    state.sound_exists = data
  },
  SET_BANK_PROFILES(state, data) {
    state.bankProfiles = data
  },
  SET_CLASS_ID(state, data) {
    state.class_id = data
  },
  SET_BRANCH_ID(state, data) {
    state.branch_id = data
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        id_card_activated: context.state.id_card_activated,
        photo_exists: context.state.photo_exists,
        sound_exists: context.state.sound_exists,
        status_id: context.state.status_id,
        acps_id: context.state.acps_id,
        linked_with_parent: context.state.linked_with_parent,
        all_branch: Array.isArray(context.state.branch_id)
          ? context.state.branch_id.length
            ? undefined
            : true
          : true,
        branch_id: context.state.branch_id,
        filter: {
          is_print_card: context.state.is_print_card,
          student_in_class: context.state.class_id
        }
      },
      attrubutes
    )
    return StudentProfile.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  store(context, data) {
    return StudentProfile.store(data)
  },

  update(context, data) {
    return StudentProfile.update(data)
  },
  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await StudentProfile.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },
  destroy(context, data) {
    return StudentProfile.destroy(data)
  },

  updateStatus(context, data) {
    return StudentProfile.updateStatus(data)
  },
  checkStatusBySubProgram(context, data) {
    return StudentProfile.checkStatusBySubProgram(data)
  },
  updateStatusBySubProgram(context, data) {
    return StudentProfile.updateStatusBySubProgram(data)
  },

  printCard(context, data) {
    return StudentProfile.printCard({
      params: {
        template: data.template,
        side: data.side,
        type: data.type,
        student_id_list: data.student_id_list,
        valid_date: data.valid_date
      }
    })
  },

  // generate student list as excel
  exportExcel(context, data) {
    return StudentProfile.exportExcel(data)
  },

  fetchInfoInquiries(context, attributes = {}) {
    let params = {
      page: -1,
      search: attributes.search,
      fields: {
        setup_student_inquiries:
          'first_name_kh,last_name_kh,first_name_en,last_name_en,gender,date_of_birth,place_of_birth,province_code,district_code,commune_code,village_code,street,house,ac_st_id,na_id,email,facebook,linkin,telegram,line,we_chat,contact_name,relationship,contact_number,inquiry_id,from_school'
      },
      filter: {
        is_registered: false,
        branch_id: attributes.branch_id
      },
      ...attributes
    }

    return StudentInquiry.get({ params }).then(response => {
      return Promise.resolve(response.data)
    })
  },
  fetchParents(context, attributes = {}) {
    let params = {
      page: context.state.pagination.page,
      perPage: context.state.pagination.perPage,
      search_name_en: context.state.parent_search,
      fields: {
        setup_student_parent_profiles:
          'student_parent_id,father_name_kh,father_name_en,father_photo,mother_name_kh,mother_name_en,mother_photo'
      },
      ...attributes
    }

    return ParentProfile.get({ params }).then(response => {
      return Promise.resolve(response.data)
    })
  },
  fetchStudyTime(context, attributes = {}) {
    let params = {
      page: -1,
      fields: {
        academic_study_times: 'ac_st_id,study_time,session'
      },
      ...attributes
    }

    return StudyTime.get({ params }).then(response => {
      context.commit('SET_STUDY_TIMES', response.data)
      return Promise.resolve(response)
    })
  },
  fetchCorporatePartner(context, attributes = {}) {
    let params = {
      page: -1,
      fields: {
        setup_corporate_partner_profiles:
          'cpp_id,partner_name_kh,partner_name_en'
      },
      ...attributes
    }

    return CorporatePartner.get({ params }).then(response => {
      context.commit('SET_CORPORATE_PARTNERS', response.data)
      return Promise.resolve(response)
    })
  },
  async uploadPhoto(context, data) {
    return StudentProfile.uploadPhoto(data)
  },
  fetchNationality(context) {
    return StudentProfile.nationality()
  },
  fetchReligion(context) {
    return StudentProfile.religion()
  },
  async uploadAudio(context, data) {
    return StudentProfile.uploadAudio(data)
  },
  async dataForSchoolInformation(context) {
    if (!context.state.itemLists.length > 0) {
      let response = await StudentProfile.itemList()
      context.commit('SET_ITEM_LISTS', response.data)
    }
    if (!context.state.provinces.length > 0) {
      let response = await StudentProfile.province()
      context.commit('SET_PROVINCES', response.data)
    }
  },
  async getStudentStatus(context) {
    if (!context.state.studentStatus.length > 0) {
      let response = await StudentProfile.getStatus()
      context.commit('SET_STATUS', response.data)
    }
    if (!context.state.provinces.length > 0) {
      let response = await StudentProfile.province()
      context.commit('SET_PROVINCES', response.data)
    }
  },
  async getDistrict(context, province_code) {
    if (!province_code) return
    context.commit('SET_DISTRICTS', [])
    context.commit('SET_COMMUNES', [])
    context.commit('SET_VILLAGES', [])
    let response = await StudentProfile.district(province_code)
    context.commit('SET_DISTRICTS', response.data)
  },
  async getCommune(context, district_code) {
    if (!district_code) return
    context.commit('SET_COMMUNES', [])
    context.commit('SET_VILLAGES', [])
    let response = await StudentProfile.commune(district_code)
    context.commit('SET_COMMUNES', response.data)
  },
  async getVillage(context, commune_code) {
    if (!commune_code) return
    context.commit('SET_VILLAGES', [])
    let response = await StudentProfile.village(commune_code)
    context.commit('SET_VILLAGES', response.data)
  },
  getBranch(context, attributes = {}) {
    return branch.get({
      params: {
        fields: {
          setup_branch_profiles: 'branch_id,branch_name_en'
        },
        page: -1
      },
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getSubProgram(context, attributes = {}) {
    return SubProgram.get({
      params: {
        fields: {
          academic_program_subs: 'acps_id,acps_name_foreign'
        },
        page: -1
      },
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getClass(context, acps_id) {
    return ClassOperation.get({
      params: {
        fields: {
          academic_classes: 'class_id,class_name'
        },
        filter: {
          acps_id: acps_id,
          ac_status_id: [1, 3]
        },
        page: -1
      },
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getStudent(context, attributes = {}) {
    if (attributes.class_id === '' || attributes.class_id === null) return

    return StudentProfile.get({
      params: {
        page: -1,
        fields: {
          setup_student_profiles:
            'student_id,card_number,first_name_en,last_name_en,gender,card_number,ext_card_number'
        },
        filter: {
          student_in_class: attributes.class_id
        }
      }
    }).then(response => {
      return Promise.resolve(response)
    })
  },
  increasePrinterCardCounter(context, studentId) {
    return StudentProfile.increasePrinterCardCounter(studentId)
  },
  async getClassOperation(context, attrubutes = {}) {
    let params = Object.assign(
      {
        include: 'academic_term,teacher,academic_study_time,academic_status',
        filter: {
          ac_status_id: '1,3'
        },
        fields: {
          academic_classes:
            'class_id,class_name,ac_term_id,teacher_resp_id,ac_st_id,acps_id,acp_id,ac_status_id'
        }
      },
      attrubutes
    )
    return await operationClass.get({ params })
  },
  fetchBankProfile(context, attributes = {}) {
    let params = {
      page: -1,
      include: 'bank_accounts',
      fields: {
        setup_payment_bank_profiles: 'bank_id,bank_name'
      },
      ...attributes
    }

    return bankProfile.get({ params }).then(response => {
      context.commit('SET_BANK_PROFILES', response.data)
      return Promise.resolve(response)
    })
  },
  async addParent(context, data) {
    return StudentProfile.addParent(data)
  },
  checkChangeModeExternalTrueToFalse(context, data) {
    return StudentProfile.checkChangeModeExternalTrueToFalse(data)
  },
  checkChangeModeExternalFalseToTrue(context, data) {
    return StudentProfile.checkChangeModeExternalFalseToTrue(data)
  },
}
